import { graphql } from 'react-relay';

// Category Queries
export const aiAssetLibraryCategoriesQuery = graphql`
    query assetLibraryQueriesAIAssetLibraryCategoriesQuery($searchName: String, $sortBy: AIAssetLibrarySortBy, $sortDirection: SortDirection) {
        aiAssetLibraryCategories(searchName: $searchName, sortBy: $sortBy, sortDirection: $sortDirection, first: 50) {
            nodes {
                id
                name
                sortOrder
                createdDate
                modifiedDate
            }
        }
    }
`;

// Asset Queries
export const aiAssetLibraryAssetsQuery = graphql`
    query assetLibraryQueriesAIAssetLibraryAssetsQuery(
        $categoryID: Int
        $assetType: String
        $sourceToolID: String
        $searchName: String
        $sortBy: AIAssetLibrarySortBy
        $sortDirection: SortDirection
    ) {
        ...assetsGrid_query
            @arguments(
                categoryID: $categoryID
                assetType: $assetType
                sourceToolID: $sourceToolID
                searchName: $searchName
                sortBy: $sortBy
                sortDirection: $sortDirection
            )
    }
`;

// Category Mutations
export const createAIAssetLibraryCategoryMutation = graphql`
    mutation assetLibraryQueriesCreateAIAssetLibraryCategoryMutation($name: String!, $sortOrder: Int!) {
        createAIAssetLibraryCategory(name: $name, sortOrder: $sortOrder) {
            id
            name
            sortOrder
            createdDate
            modifiedDate
        }
    }
`;

export const updateAIAssetLibraryCategoryMutation = graphql`
    mutation assetLibraryQueriesUpdateAIAssetLibraryCategoryMutation($id: ID!, $name: String!, $sortOrder: Int!) {
        updateAIAssetLibraryCategory(id: $id, name: $name, sortOrder: $sortOrder) {
            id
            name
            sortOrder
            createdDate
            modifiedDate
        }
    }
`;

export const deleteAIAssetLibraryCategoryMutation = graphql`
    mutation assetLibraryQueriesDeleteAIAssetLibraryCategoryMutation($id: ID!) {
        deleteAIAssetLibraryCategory(id: $id)
    }
`;

// Asset Mutations
export const saveAssetToLibraryMutation = graphql`
    mutation assetLibraryQueriesSaveAssetToLibraryMutation(
        $sourceUrl: String!
        $name: String!
        $assetType: String!
        $categoryID: Int
        $sourceToolID: String
        $metadata: AssetGenerationSettingsInput
    ) {
        saveAssetToLibrary(
            sourceUrl: $sourceUrl
            name: $name
            assetType: $assetType
            categoryID: $categoryID
            sourceToolID: $sourceToolID
            metadata: $metadata
        ) {
            id
            categoryID
            name
            assetType
            sourceToolID
            fileServerID
            filePath
            fileName
            fileUrl
            fileSizeBytes
            width
            height
            durationSeconds
            thumbnailUrl
            metadata {
                toolId
                toolName
                prompt
                negativePrompt
                model
                width
                height
                seed
                strength
                steps
                guidanceScale
                sourceImageUrls
                styleImageUrl
                maskImageUrl
                backgroundPreset
                backgroundImageUrl
                personPreset
                personImageUrl
                clothingPreset
                clothingImageUrl
                posePreset
                effectPreset
                surfacePreset
                moodPreset
                materialPreset
                colorPreset
                layoutPreset
                formatPreset
                stylePreset
                videoPreset
                scaleFactor
                durationSeconds
                resolution
                aspectRatio
                generateAudio
                language
                title
                subtitle
                ctaText
                savedAt
            }
            createdDate
            modifiedDate
            categoryName
        }
    }
`;

export const updateAIAssetLibraryAssetMutation = graphql`
    mutation assetLibraryQueriesUpdateAIAssetLibraryAssetMutation($id: ID!, $name: String!, $categoryID: Int) {
        updateAIAssetLibraryAsset(id: $id, name: $name, categoryID: $categoryID) {
            id
            categoryID
            name
            assetType
            sourceToolID
            fileServerID
            filePath
            fileName
            fileUrl
            fileSizeBytes
            width
            height
            durationSeconds
            thumbnailUrl
            metadata {
                toolId
                toolName
                prompt
                negativePrompt
                model
                width
                height
                seed
                strength
                steps
                guidanceScale
                sourceImageUrls
                styleImageUrl
                maskImageUrl
                backgroundPreset
                backgroundImageUrl
                personPreset
                personImageUrl
                clothingPreset
                clothingImageUrl
                posePreset
                effectPreset
                surfacePreset
                moodPreset
                materialPreset
                colorPreset
                layoutPreset
                formatPreset
                stylePreset
                videoPreset
                scaleFactor
                durationSeconds
                resolution
                aspectRatio
                generateAudio
                language
                title
                subtitle
                ctaText
                savedAt
            }
            createdDate
            modifiedDate
            categoryName
        }
    }
`;

export const deleteAIAssetLibraryAssetMutation = graphql`
    mutation assetLibraryQueriesDeleteAIAssetLibraryAssetMutation($id: ID!) {
        deleteAIAssetLibraryAsset(id: $id)
    }
`;
